"use strict";

exports.__esModule = true;
var _DeviceTagListContext = require("./DeviceTagListContext");
Object.keys(_DeviceTagListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTagListContext[key]) return;
  exports[key] = _DeviceTagListContext[key];
});
var _DeviceTagListLoader = require("./DeviceTagListLoader");
Object.keys(_DeviceTagListLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTagListLoader[key]) return;
  exports[key] = _DeviceTagListLoader[key];
});